import { Reducer } from 'redux';
import { Profile } from 'types';

import { Actions } from 'store/actions/auth.action';
import {
  AUTH_SET_PROFILE,
  AUTH_UPDATE_AVATAR,
  AUTH_UPDATE_AVATAR_URL,
  AUTH_UPDATE_NAME,
  AUTH_UPDATE_EMAIL,
  AUTH_UPDATE_PASSWORD,
  AUTH_REQUEST_PROFILE,
  AUTH_FAILURE_REQUEST,
  AUTH_FAILURE_UPDATE,
  AUTH_UPDATE_PROFILE,
  AUTH_RESET_MESSAGE,
  AUTH_LOGOUT,
  AUTH_GOVT_ID,
} from 'store/types/auth.type';

import { RootReducerType } from './index';
import { BASE_URL } from '../../utils/axios';

const AVATAR_URL = `${BASE_URL}/api/v2/user/avatar`;

export type State = {
  profile?: Profile;
  isFetching: boolean;
  isUpdating: boolean;
  error: string;
  success: string;
  govtId: {
    doc_file_name?: string
    gov_doc_url?: string
    govt_document_type?: string
    id?: number
  }[]
};

const initialState: State = {
  profile: undefined,
  isFetching: false,
  isUpdating: false,
  error: '',
  success: '',
  govtId: []
};

export const authReducer: Reducer<State, Actions> = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_SET_PROFILE:
      return { ...state, profile: { ...action.data, avatarUrl: '' } as Profile, isFetching: false };
    case AUTH_UPDATE_AVATAR_URL:
      return { ...state, profile: state.profile ? { ...state.profile, avatarUrl: action.url } : state.profile };
    case AUTH_REQUEST_PROFILE:
      return { ...state, isFetching: true, error: '', success: '' };
    case AUTH_UPDATE_PROFILE:
      return { ...state, isUpdating: true, error: '', success: '' };
    case AUTH_FAILURE_REQUEST:
      return { ...state, isFetching: false, error: action.error };
    case AUTH_FAILURE_UPDATE:
      return { ...state, isUpdating: false, error: action.error };
    case AUTH_UPDATE_AVATAR:
      return { ...state, isUpdating: false };
    case AUTH_UPDATE_NAME:
      return { ...state, profile: { ...state.profile, ...action.names } as Profile, isUpdating: false, success: 'Changes saved successfully!' };
    case AUTH_UPDATE_EMAIL:
      return { ...state, profile: { ...state.profile, email: action.email } as Profile, isUpdating: false };
    case AUTH_UPDATE_PASSWORD:
      return { ...state, isUpdating: false, error: action.error, success: action.success };
    case AUTH_RESET_MESSAGE:
      return { ...state, error: '', success: '' }
    case AUTH_GOVT_ID:
      return {...state, isUpdating: false, govtId: action.payload }
    case AUTH_LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export const authSelector = (state: RootReducerType) => state.auth;
export default authReducer;
